import {
  Hero as HeroComponent,
  IAsset,
  IHero as IHeroComponent,
  IImageComponent,
} from 'components/Hero';

import type { HeroComponent as THeroComponent } from 'server/repository/hygraph/generated/graphqlTypes';
import type { ISharedTemplateProps } from '../TemplateMapper/types';

interface IHero {
  templateProps: THeroComponent;
}

export const Hero = (props: IHero & ISharedTemplateProps & IHeroComponent) => {
  const {
    themeName,
    templateProps: {
      topRightImageAsset,
      bottomLeftImageAsset,
      title,
      alignment,
      verticalAlignment,
      verticalAlignmentMobile,
      description,
      imageComponent,
      mobileImage,
      superText,
    },
    textColor,
    primarySubBrandColor,
  } = props;
  return (
    <HeroComponent
      topRightImageAsset={topRightImageAsset as IAsset}
      bottomLeftImageAsset={bottomLeftImageAsset as IAsset}
      title={title}
      alignment={alignment}
      verticalAlignment={verticalAlignment}
      verticalAlignmentMobile={verticalAlignmentMobile}
      description={description}
      imageComponent={imageComponent as IImageComponent}
      mobileImage={mobileImage as IAsset}
      superText={superText}
      textColor={textColor}
      primarySubBrandColor={primarySubBrandColor}
      themeName={themeName}
    />
  );
};
